import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { PROMPT_TEMPLATE_REPOSITORY } from '../../core';
import { PROMPT_TEMPLATE_API } from '../data-sources';
export var PromptTemplateWebRepository = /*#__PURE__*/function () {
  function PromptTemplateWebRepository(promptTemplateApi) {
    _classCallCheck(this, PromptTemplateWebRepository);

    this.promptTemplateApi = promptTemplateApi;
  }

  _createClass(PromptTemplateWebRepository, [{
    key: "getPromptTemplates",
    value: function () {
      var _getPromptTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.promptTemplateApi.getPromptTemplates(query);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPromptTemplates(_x) {
        return _getPromptTemplates.apply(this, arguments);
      }

      return getPromptTemplates;
    }()
  }]);

  return PromptTemplateWebRepository;
}();
export var promptTemplateWebRepositoryProvider = {
  provide: PROMPT_TEMPLATE_REPOSITORY,
  useFactory: function useFactory(promptTemplateApi) {
    return new PromptTemplateWebRepository(promptTemplateApi);
  },
  inject: [PROMPT_TEMPLATE_API]
};